import { useState } from 'react';
import * as St from './weget-commerce-api-store-list.styled';
import { AddCommerceApiStoreInfoModal } from './modals/add-commerce-api-store-info-modal/add-commerce-api-store-info-modal';
import { useCommerceApiStoreInfoValueContextHook } from '../../contexts/CommerceApiStoreInfoContext';
import { EditCommerceApiStoreInfoModal } from './modals/edit-commerce-api-store-info-modal/edit-commerce-api-store-info-modal';
import { useSelectedCommerceApiStoreInfosActionsContextHook, useSelectedCommerceApiStoreInfosValueContextHook } from '../../contexts/SelectedCommerceApiStoreInfosContext';

export function WegetCommerceApiStoreList(props) {
    const commerceApiStoreInfosValueContextHook = useCommerceApiStoreInfoValueContextHook();
    const [addModalOpen, setAddModalOpen] = useState(false);

    return (
        <>
            <St.Container>
                <St.Title.Container>
                    <St.Title.Name>
                        <span style={{color:'#03C75A'}}>스마트스토어</span> 관리 목록
                    </St.Title.Name>
                    <St.Title.AddButton
                        type='button'
                        onClick={() => setAddModalOpen(true)}
                    >
                        추가
                    </St.Title.AddButton>
                </St.Title.Container>
                <St.StoreList.Container>
                    {commerceApiStoreInfosValueContextHook?.commerceApiStoreInfos?.map((storeInfo, index) => {
                        return (
                            <StoreInfoItem
                                key={storeInfo?.id}
                                commerceApiStoreInfo={storeInfo}
                                index={index}
                            />
                        )
                    })}
                </St.StoreList.Container>
            </St.Container>

            {addModalOpen &&
                <AddCommerceApiStoreInfoModal
                    open={addModalOpen}
                    onClose={() => setAddModalOpen(false)}
                />
            }
        </>
    );
}

function StoreInfoItem({
    commerceApiStoreInfo,
    index,
}) {
    const selectedCommerceApiStoreInfosValueContextHook = useSelectedCommerceApiStoreInfosValueContextHook();
    const selectedCommerceApiStoreInfosActionsContextHook = useSelectedCommerceApiStoreInfosActionsContextHook();

    const [editMoalOpen, setEditModalOpen] = useState(false);

    const isSelected = selectedCommerceApiStoreInfosValueContextHook?.commerceApiStoreInfos?.findIndex(storeInfo => storeInfo?.id === commerceApiStoreInfo?.id) > -1;

    return (
        <>
            <St.StoreList.Item
                className={`${isSelected ? 'selected' : ''}`}
                onClick={() => {
                    selectedCommerceApiStoreInfosActionsContextHook?.commerceApiStoreInfos?.setValue(prev => {
                        if (isSelected) {
                            return prev.filter(storeInfo => storeInfo?.id !== commerceApiStoreInfo?.id);
                        }
                        return [...prev, commerceApiStoreInfo];
                    });
                }}
            >
                <St.StoreList.ItemName>
                    {commerceApiStoreInfo?.storeName}
                </St.StoreList.ItemName>
                <St.StoreList.ItemEditButton
                    type='button'
                    onClick={(e) => { e.stopPropagation(); setEditModalOpen(true); }}
                >
                    수정
                </St.StoreList.ItemEditButton>
            </St.StoreList.Item>

            {editMoalOpen &&
                <EditCommerceApiStoreInfoModal
                    open={editMoalOpen}
                    onClose={() => setEditModalOpen(false)}
                    commerceApiStoreInfo={commerceApiStoreInfo}
                />
            }
        </>
    );
}